import moment from 'moment'

export function getFinancialPeriod(startDate, periods, FeDateFormat) {
  const BeDateFormat = 'YYYY-MM-DD'
  let financialPeriodToPreselect = periods.find(period => {
    return (
      moment(startDate, [FeDateFormat, BeDateFormat]).isSameOrAfter(moment(period.start_date, [BeDateFormat])) &&
      moment(startDate, [FeDateFormat, BeDateFormat]).isSameOrBefore(moment(period.end_date, [BeDateFormat]))
    )
  })

  // rare case when sub period doesn't fall in any financial period
  if (!financialPeriodToPreselect) {
    financialPeriodToPreselect = periods[periods.length - 1] //preselect the last period
  }

  return financialPeriodToPreselect
}
